import React from "react";
import get from "lodash.get";
import merge from "deepmerge";
import {
  Footer as FooterComponent,
  IFooterData
} from "@comparaonline/ui-navigation-footer/dist/components/Footer";
import { Menu } from "@comparaonline/ui-navigation-footer/dist/components/Menu/desktop";
import { MenuMobile } from "@comparaonline/ui-navigation-footer/dist/components/Menu/mobile";
import { PaymentMethods } from "@comparaonline/ui-navigation-footer/dist/components/PaymentMethods";
import { ScheduleContent } from "@comparaonline/ui-navigation-footer/dist/components/Schedule";
import { Trademark } from "@comparaonline/ui-navigation-footer/dist/components/Trademark";

import { useAppContext } from "../lib/appContext";

const emptySchedule = {
  sections: { schedule: { title: "", content: "" } }
};

export const Footer = () => {
  const { footer, isMobile, country, businessUnitConfig } = useAppContext();
  const displayPhone = get(businessUnitConfig, "navigation.displayPhoneNumber", true);
  const footerData = (displayPhone ? footer : merge(footer, emptySchedule)) as IFooterData;

  return (
    <FooterComponent
      data={footerData}
      trademarkComponent={Trademark}
      menuComponent={isMobile ? MenuMobile : Menu}
      scheduleComponent={ScheduleContent}
      paymentComponent={PaymentMethods}
      countrySelected={country}
    />
  );
};
